import React from 'react'
import Popup from './Popup'

type Props = {
    onClose: () => void
}

export function ProSubscriptionInfoPopup({ onClose }: Props) {
    return (
        <Popup onClose={onClose}>
            <div className="security-info-popup">
                <h3 className="H3_21">Что входит в подписку Pro?</h3>

                <div className="security-section pro-subscription-notice">
                    <p>
                        <strong>Важно:</strong> подписка Pro <strong>не включает пакет документов</strong> и не
                        заменяет тариф на договоры. Для отправки договоров клиентам нужно отдельно оформить
                        пакетный или безлимитный тариф.
                    </p>
                </div>

                <div className="security-section">
                    <h4 className="Subheader_17">Оформление страницы подписания</h4>
                    <p>
                        Настройте favicon, логотип и корпоративный цвет — клиент увидит ваш бренд
                        на странице договора и при регистрации, а не стандартный интерфейс Okidoki.
                    </p>
                </div>

                <div className="security-section">
                    <h4 className="Subheader_17">Команда без ограничений</h4>
                    <p>
                        Добавляйте неограниченное количество сотрудников в аккаунт без доплат
                        за каждого пользователя.
                    </p>
                </div>

                <div className="security-section">
                    <h4 className="Subheader_17">ИИ-ассистент подписания</h4>
                    <p>
                        Помогает клиенту пройти сделку до конца: отвечает на вопросы по документу
                        и подсказывает следующие шаги на странице подписания.
                    </p>
                </div>

                <div className="security-section">
                    <h4 className="Subheader_17">Юридическая помощь</h4>
                    <p>
                        Консультации по вашим договорам и сопровождение при работе с шаблонами.
                    </p>
                </div>

                <div className="security-section">
                    <h4 className="Subheader_17">Интеграции и настройка</h4>
                    <p>
                        Помощь с подключением RealtyCalendar, AmoCRM и Bitrix24 — настройка вебхуков
                        и сценариев обмена данными.
                    </p>
                </div>
            </div>
        </Popup>
    )
}
